// General
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import c from '../../components/LoginModal/LoginModal.css';
import bt from '../../components/commonStyle.css';
import {
  Modal
} from 'react-bootstrap';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeSignupModal, openLoginModal } from '../../actions/modalActions';

// Components
import SocialLogin from '../SocialLogin';
import RegisterForm from '../RegisterForm';
import Link from '../Link';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

const SignupModal = () => {
  const signupModal = useSelector(state => state.modalStatus.isSignupModalOpen);
  const [eyeActive, setEyeActive] = useState(false);
  const logoSrc = eyeActive ? '/eslipin-smile.svg' : '/eslipin-sleep.svg';
  const dispatch = useDispatch();

  return (
    <Modal show={signupModal} animation={false} onHide={() => dispatch(closeSignupModal())}
      dialogClassName={'loginModal'} >
      <Modal.Body>
        <img
          src="/eslipin-logo-primario.svg"
          alt="Eslipin"
          className={c.primaryLogo}
        />
        <div className={c.logoTopContainer}>
          <img
            src="/eslipin-logo-secundario-blue.png"
            alt="Eslipin"
            className={c.logoTop}
          />
        </div>
        <div className={c.contentWrapper}>
          <div className={c.root}>
            <a
              className={c.closeBtn}
              onClick={() => dispatch(closeSignupModal())}
            >
              <span>×</span>
            </a>
            <div className={c.welcomeSection}>
                <img
                  src={logoSrc}
                  alt="Eslipin"
                  className={c.logoImage}
                />
              <h2 className={c.welcomeTitle}>
                <FormattedMessage {...messages.signup} />
              </h2>
            </div>
            <RegisterForm onEyeToggle={setEyeActive} />
            <h4 className={c.lineThrough}>
              <span className={c.linetext}><FormattedMessage {...messages.or} /></span>
            </h4>
            <SocialLogin />
            <p className={c.linkText}>
              <FormattedMessage {...messages.alreadyHaveAccount} />
              <Link className={c.modalCaptionLink} onClick={() => dispatch(openLoginModal())}>
                <FormattedMessage {...messages.logInHere} />
              </Link>
            </p>
          </div>
          <div className={c.appStoreSection}>
            <p className={c.appStoreText}>
              <FormattedMessage {...messages.appStoreAvailable} />
            </p>
            <div className={c.appStoreIcons}>
              <img
                src="/SiteImages/playStore.svg"
                alt="Google Play"
                className={c.storeIcon}
              />
              <img
                src="/SiteImages/appStore.svg"
                alt="App Store"
                className={c.storeIcon}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

SignupModal.propTypes = {
  closeSignupModal: PropTypes.func,
  signupModal: PropTypes.bool,
  openLoginModal: PropTypes.func,
};

export default withStyles(c, bt)(SignupModal);
